module.exports = __webpack_public_path__ + "static/media/loudly-crying-face-svgrepo-com.971e9790.svg";